import 'whatwg-fetch';
import * as constants from '../constants/actions';



/******************************
*******  Synchronous  *********
******************************/

export function headerTitle(title) {
  return {
    type: constants.HEADER_TITLE,
    title
  };
}

export function headerCloseSendLeadDropdown() {
  return {
    type: constants.HEADER_CLOSE_SEND_LEAD,
  };
}

export function headerOpenSendLeadDropdown(card) {
  return {
    type: constants.HEADER_OPEN_SEND_LEAD,
    card
  };
}


/******************************
*******  Asynchronous  ********
******************************/

